module.exports = __webpack_public_path__ + "img/node-mac-address.8fa134d3.png";